import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import * as settingsAction from "store/entities/settingsInfo/action";
import * as accountActions from "store/auth/account/action";


import FormDrawer from '../form-drawer';
import { ButtonLoader, Input } from "components/__new/common/form";
import validate from "utils/validate";
import { REGEX_VALUES } from 'utils/regexValues';
import helpcircle from "assets/images/icons/help-circle.svg";


const CompanyContactInfoModal = (props) => {
const {isOpen, setIsOpen, company} = props;
const dispatch = useDispatch();

const { companyInfoSettings, companyInfoSettingsLoading } = useSelector((s) => s.entities.settingsInfo);
const [isUpdated,  setIsUpdated] = useState(false)

const [form, setForm] = useState({
    primaryContactPerson: company?.primaryContactPerson ?? '',
        primaryContactEmail: company?.primaryContactEmail ?? '',
        secondaryContactPerson: company?.secondaryContactPerson ?? '',
        secondaryContactEmail: company?.secondaryContactEmail ?? '',
});


useEffect(() => {
        const newForm = {
        primaryContactPerson: company?.primaryContactPerson ?? '',
        primaryContactEmail: company?.primaryContactEmail ?? '',
        secondaryContactPerson: company?.secondaryContactPerson ?? '',
        secondaryContactEmail: company?.secondaryContactEmail ?? '',
        }
        
        setForm(newForm)
    }, [company]);

    const handleCompanyContactInfoChangeName = (e) => {
        const { name, value } = e.target;
        if ((!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY_WITH_SPACE.test(value) || value.length > 50)) {
            return;
          }
        setForm(prevForm => ({
            ...prevForm,
            [name]: value
        }));
    };

    // const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handleCompanyContactInfoChangeEmail = (e) => {
        const { name, value } = e.target;
        // ADD VALIDATION TO EMAIL
        if ((value.length > 50)) {
            return;
          }
        setForm(prevForm => ({
            ...prevForm,
            [name]: value
        }));
    };
    
    const submitForm = async (e) => {
        e.preventDefault();
        
        const errors = validate(form
        );
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const params = {
                primaryContactPerson: form.primaryContactPerson,
                primaryContactEmail: form.primaryContactEmail,
                secondaryContactPerson: form.secondaryContactPerson,
                secondaryContactEmail: form.secondaryContactEmail,
                }
    
            dispatch(settingsAction.updateCompanyInfoSettings(params));
            setIsUpdated(true);
        }
    
    }
    
    
    
 useEffect(() => {
    if (companyInfoSettings?.id && isUpdated){
        dispatch(accountActions.getEmployerInfo());
        dispatch(settingsAction.resetUpdateCompanyInfo());
        setIsOpen(false);
        setIsUpdated(false);
        toast.success("Company contact info updated successfully");
    } 
    }
    //   eslint-disable-next-line
, [companyInfoSettings])

    return (
    
    <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={submitForm} className="p-6">
                <FormDrawer.Title
                    title="Edit Contact Info"
                    description="Manage your company's contact information"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <hr />
                
                <div className='py-4 text-ep-gray-700 font-medium'>
                    <div className="relative">
                        <Input
                            type="text"
                            label="Primary Contact Person"
                            placeholder=""
                            name={"primaryContactPerson"}
                            value={form.primaryContactPerson}
                            onChange={handleCompanyContactInfoChangeName}
                        />
                        <img style={{top: '2px', left: '156px'}} className='absolute' src={helpcircle} alt="" />
                        </div>
                    
                    <Input
                        type="email"
                        label="Primary Contact Email"
                        placeholder=""
                        name={"primaryContactEmail"}
                        value={form.primaryContactEmail}
                        onChange={handleCompanyContactInfoChangeEmail}
                    />
                    <div className="relative">
                        <Input
                            type="text"
                            label="Secondary Contact Person"
                            placeholder=""
                            name={"secondaryContactPerson"}
                            value={form.secondaryContactPerson}
                            onChange={handleCompanyContactInfoChangeName}
                        />
                        <img style={{top: '2px', left: '176px'}} className='absolute' src={helpcircle} alt="" />
                    </div>
                    <Input
                        type="email"
                        label="Secondary Contact Email"
                        placeholder=""
                        name={"secondaryContactEmail"}
                        value={form.secondaryContactEmail}
                        onChange={handleCompanyContactInfoChangeEmail}
                    />
                </div>
                
                <div className="p-1 mt-4 flex justify-end space-x-3">
                    <button onClick={() => setIsOpen(false)} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                        Cancel
                    </button>
                    <ButtonLoader loading={companyInfoSettingsLoading} disabled={companyInfoSettingsLoading} type="submit" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Save Changes
                    </ButtonLoader>
                </div>
            </form>
        </FormDrawer>
  )
}

export default CompanyContactInfoModal
